import React from "react";
import { Button, Table } from "react-bootstrap";
import ProcessStatusBadge from "./ProcessStatusBadge";

export default function ProcessQueueTable({
  rows = [],
  onManage,
  onTake,
  onAssign,
  onRelease,
  loading = false,
  includeProcess = false,
}) {
  return (
    <div className="table-responsive">
      <Table hover className="align-middle crm-postventa-v2-table">
        <thead>
          <tr>
            {includeProcess && <th>Proceso</th>}
            <th>Comercio</th>
            <th>CUIT</th>
            <th>Comercio / Terminal</th>
            <th>Origen</th>
            <th>Estado</th>
            <th>Intento</th>
            <th>Canal</th>
            <th>Proxima accion</th>
            <th>Fecha proxima</th>
            <th>Prioridad</th>
            <th>Responsable</th>
            <th>Asignado</th>
            <th className="text-end">Acciones</th>
          </tr>
        </thead>
        <tbody>
          {!rows.length ? (
            <tr>
              <td colSpan={includeProcess ? 14 : 13} className="text-center text-muted py-4">
                No hay instancias para mostrar.
              </td>
            </tr>
          ) : (
            rows.map((item) => (
              <tr key={`${item.procesoCodigo}-${item.id}`}>
                {includeProcess && <td>{item.procesoLabel || item.procesoCodigo || "-"}</td>}
                <td>{item.comercio || "-"}</td>
                <td>{item.cuit || "-"}</td>
                <td>
                  <div>{item.numeroComercio || "-"}</div>
                  <div className="small text-muted">{item.numeroTerminal || "-"}</div>
                </td>
                <td>{item.procesoOrigenLabel || item.procesoOrigenCodigo || "-"}</td>
                <td>
                  <ProcessStatusBadge>{item.estadoLabel || item.estadoActual}</ProcessStatusBadge>
                </td>
                <td>{item.intentoActual || "-"}</td>
                <td>{item.canalPermitido || "-"}</td>
                <td>{item.accionPermitida || "-"}</td>
                <td>{item.fechaProximaAccion || "-"}</td>
                <td>{item.prioridad || "-"}</td>
                <td>
                  <div>{item.responsable || "Sin asignar"}</div>
                  {item.esSoloLectura ? (
                    <div className="small text-muted">{item.mensajeSoloLectura || "Solo lectura"}</div>
                  ) : null}
                </td>
                <td>{item.responsableAsignadoEn || "-"}</td>
                <td className="text-end">
                  <div className="d-flex flex-wrap justify-content-end gap-2">
                    {item.puedeTomar ? (
                      <Button size="sm" variant="outline-primary" onClick={() => onTake?.(item)} disabled={loading}>
                        Tomar
                      </Button>
                    ) : null}
                    {item.puedeAsignar ? (
                      <Button size="sm" variant="outline-secondary" onClick={() => onAssign?.(item)} disabled={loading}>
                        Asignar
                      </Button>
                    ) : null}
                    {item.puedeLiberar ? (
                      <Button size="sm" variant="outline-warning" onClick={() => onRelease?.(item)} disabled={loading}>
                        Liberar
                      </Button>
                    ) : null}
                    <Button
                      size="sm"
                      variant={item.esSoloLectura || item.puedeGestionar === false ? "outline-dark" : "success"}
                      onClick={() => onManage?.(item)}
                      disabled={loading}
                    >
                      {item.esSoloLectura || item.puedeGestionar === false ? "Ver detalle" : "Gestionar"}
                    </Button>
                  </div>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
    </div>
  );
}
